import styled from 'styled-components';

import metal_filled_circle from 'assets/images/product_picker_page/metal_filled_circle.webp';

export const MetalFilledCircle = () => (
  <CircleImage srcSet={metal_filled_circle} alt="" />
);

const CircleImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;
